import {
  allFetch
} from "../Domain";

/**
 * @description 薪資表作業
 */
export const UserSalaryLog = (() => {

  /**
   * @description 查詢使用者薪資紀錄(編輯用)
   * @param {string} ussm_id           使用者薪資設定主項流水號
   * @param {string} user_id           使用者流水號
   * @param {string} ul_id             職務流水號
   * @param {string} department_id     部門流水號
   * @param {string} date              年月日
   */
  const UserSalaryLogSearch = async (obj = {
    ussm_id: '',
    user_id: '',
    ul_id: '',
    department_id: '',
    date: ''
  }) => {
    return await allFetch("UserSalaryLog/UserSalaryLogSearch", obj);
  }

  /**
 * @description 更新使用者薪資紀錄
 * @param {string} ussm_id        使用者薪資設定主項流水號
 * @param {string} list           使用者薪資資料們
 */
  const UserSalaryLogUpdate = async (obj = {
    ussm_id: '',
    list: ''
  }) => {
    return await allFetch("UserSalaryLog/UserSalaryLogUpdate", obj);
  }

  /**
   * @description 刪除整條使用者薪資紀錄
   * @param {string} ussm_id           使用者薪資設定主項流水號
   * @param {string} user_id           使用者流水號
   * @param {string} date              年月日
   */
  const UserSalaryLogDelete = async (obj = {
    ussm_id: '',
    user_id: '',
    date: ''
  }) => {
    return await allFetch("UserSalaryLog/UserSalaryLogDelete", obj);
  }

  /**
   * @description 查詢使用者薪資紀錄(各種薪資表總計)
   * @param {string} user_id       使用者流水號
   * @param {string} date_start    年月日起
   * @param {string} date_end      年月日迄
   */
  const UserSalaryLogSearchOwn = async (obj = {
    user_id: '',
    date_start: '',
    date_end: ''
  }) => {
    return await allFetch("UserSalaryLog/UserSalaryLogSearchOwn", obj);
  }

  /**
   * @description 查詢使用者薪資紀錄細項
   * @param {string} user_id    使用者流水號
   * @param {string} date       年月起
   */
  const UserSalaryLogSearchOwnDetail = async (obj = {
    user_id: '',
    date: ''
  }) => {
    return await allFetch("UserSalaryLog/UserSalaryLogSearchOwnDetail", obj);
  }

  /**
   * @description 匯入使用者薪資紀錄(formdata)
   * @param {string} ussm_id    使用者薪資設定主項流水號
   * @param {string} date       年月，沒給的話excel裡要有"年月"欄位
   */
  const UserSalaryLogImport = async (formData) => {
    return await allFetch("UserSalaryLog/UserSalaryLogImport", formData);
  }

  return {
    UserSalaryLogSearch,
    UserSalaryLogDelete,
    UserSalaryLogSearchOwn,
    UserSalaryLogSearchOwnDetail,
    UserSalaryLogImport,
    UserSalaryLogUpdate
  }
})();

